import { render } from "./menu-btn.vue?vue&type=template&id=541e1fb8"
import script from "./menu-btn.vue?vue&type=script&lang=ts"
export * from "./menu-btn.vue?vue&type=script&lang=ts"

import "./menu-btn.vue?vue&type=style&index=0&id=541e1fb8&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "541e1fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('541e1fb8', script)) {
    api.reload('541e1fb8', script)
  }
  
  module.hot.accept("./menu-btn.vue?vue&type=template&id=541e1fb8", () => {
    api.rerender('541e1fb8', render)
  })

}

script.__file = "resources/scripts/components/menu-btn.vue"

export default script